export const OBSERVED_GIG_INDEX = 8;
